import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cco-catalogFilters" }
const _hoisted_2 = { class: "cco-catalogFilters__summery" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "number"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Filtre", -1)
const _hoisted_6 = { class: "o-checkbox o-checkbox__wrapper" }
const _hoisted_7 = ["id", "onUpdate:modelValue"]
const _hoisted_8 = ["for"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "field" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "10",
    height: "8",
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1 4.2L3.4 6.6L9 1",
      stroke: "white"
    })
  ])
], -1)
const _hoisted_10 = { class: "label" }

import { computed, ref, watch } from "vue";
import SlideInObject from "@/vue/components/objects/SlideInObject.vue";

import FilterIcon from "@web/assets/icon/filter.svg";
import Accordion from "./objects/Accordion.vue";
import { useStore } from "vuex";

type Props = {
	examples: Array<any>;
	filters: Array<any>;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogFilters',
  props: {
    examples: {},
    filters: {}
  },
  emits: ["changed"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();
const translations = computed(() => store.state.translations.siteTranslations);

const emit = __emit;

const props = __props;

// Slidein
const isOpen = ref(false);
const isAccordion = ref("");
function toggleSlideIn(key: string) {
	isAccordion.value = key;
	isOpen.value = !isOpen.value;

	if (changed.value && !isOpen.value) {
		emit("changed", selectedFilters.value);
	}
}

// Selected filters
const changed = ref(false);
const selectedFilters = computed(() => {
	let obj: Record<string, Number[]> = {};

	props.filters.forEach((el: any) => {
		let options = Object.values(el.options) ?? [];
		let ids = options
			.filter((obj: any) => obj.selected)
			.map((obj: any) => obj.id);
		obj[el.key] = ids;
	});

	return obj;
});

function clearFilters() {
	props.filters.forEach((el: any) => {
		let options = Object.values(el.options) ?? [];

		options.forEach((option: any) => {
			option.selected = false;
		});
	});
}

watch(
	() => selectedFilters.value,
	(newValue, oldValue) => {
		let newString = JSON.stringify(newValue);
		let oldString = JSON.stringify(oldValue);

		if (newString != oldString) {
			changed.value = true;
			return;
		}

		changed.value = false;
	},
	{ deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.examples, (example) => {
        return (_openBlock(), _createElementBlock("button", {
          class: "o-filter o-filter--default",
          key: example.key,
          onClick: ($event: any) => (toggleSlideIn(example.key))
        }, [
          _createTextVNode(_toDisplayString(example.heading) + " ", 1),
          (selectedFilters.value[example.key].length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (" + _toDisplayString(selectedFilters.value[example.key].length) + ") ", 1))
            : _createCommentVNode("", true)
        ], 8, _hoisted_3))
      }), 128)),
      _createElementVNode("button", {
        class: "o-filter",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSlideIn('')))
      }, [
        _createTextVNode(_toDisplayString(translations.value["Filters"]) + " ", 1),
        _createVNode(_unref(FilterIcon))
      ])
    ]),
    _createVNode(SlideInObject, {
      "is-open": isOpen.value,
      "aria-label": "Catalog filters",
      onClose: _cache[3] || (_cache[3] = ($event: any) => (toggleSlideIn('')))
    }, {
      head: _withCtx(() => [
        _hoisted_5
      ]),
      body: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter) => {
          return (_openBlock(), _createBlock(Accordion, {
            key: filter,
            version: "raw"
          }, {
            bar: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(filter.heading), 1)
            ]),
            contents: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.options, (option) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: option.id.toString(),
                    "onUpdate:modelValue": ($event: any) => ((option.selected) = $event)
                  }, null, 8, _hoisted_7), [
                    [_vModelCheckbox, option.selected]
                  ]),
                  _createElementVNode("label", {
                    class: "o-checkbox",
                    for: option.id.toString()
                  }, [
                    _hoisted_9,
                    _createElementVNode("span", _hoisted_10, _toDisplayString(option.heading), 1)
                  ], 8, _hoisted_8)
                ]))
              }), 256))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          class: "o-btn o-btn--outline",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (clearFilters()))
        }, _toDisplayString(translations.value["Clear all"]), 1),
        _createElementVNode("button", {
          class: "o-btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleSlideIn('')))
        }, _toDisplayString(translations.value["Show"]), 1)
      ]),
      _: 1
    }, 8, ["is-open"])
  ]))
}
}

})